import styled, { css } from 'styled-components';

export const CollapseButtonWrapper = styled.div<{$collapsed?: boolean}>`
    padding: 8px 16px 0;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
  ${({$collapsed}) =>
      $collapsed ? css`padding: 8px 4px 0` : css``
  }}
`

export const CollapseButtonContainer = styled.button<{ $active?: boolean, $collapsed?: boolean }>`
  display: flex;
    width: 100%;
  align-items: center;
  cursor: pointer;
  border-radius: 4px;
  color: var(--fg-soft, rgba(16, 24, 40, 0.75));
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  gap: 15px;
  padding: 8px 12px;

  transition: all .3s ease-in-out;
  
  &:hover {
    background: var(--neutral-container-soft, rgba(88, 93, 105, 0.05));
  }

  ${({$active}) =>
    $active
        ? css`background: var(--accent-container-soft, rgba(255, 79, 18, 0.05));
            color: var(--accent-default, rgba(255, 79, 18, 1)); &:hover{background: var(--neutral-container-soft, rgba(88, 93, 105, 0.05))}`
        : css``}

  ${({$collapsed}) =>
      $collapsed ? css`padding: 8px; display: flex; justify-content: center; align-items: center;` : css``
  }}
`;


export const CollapseIconWrapper = styled.div<{$collapsed?: boolean}>`
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all .3s ease-in-out;
  ${({$collapsed}) => 
    $collapsed ? css`transform: rotate(180deg); width: 100%;` : css`transform: rotate(0)`
  }}
`
